export default "__VITE_ASSET__Bv3qho3G__"